import React from 'react'
import { css } from 'aphrodite'
import { Container, Row, Col } from 'reactstrap'
import { Link } from 'react-router-dom'

import style from './style'

import Sitemap from '../partials/Sitemap'

const sitemapHeader = [
  { url: '/', title: 'Home' },
  { url: '/info', title: 'Info' }
]

export const Info = props => [
  <Sitemap key={0} sitemap={sitemapHeader} />,
  <section key={1} className={css(style.main.section)}>
    <Container>
      <Row>
        <Col>
          <h3 className={css(style.headers.h3)}>Sitemap</h3>
          <ul>
            <li>
              <Link to='/payments' className={css(style.list.link)}>
                Payments
              </Link>
            </li>
            <li>
              <Link to='/about' className={css(style.list.link)}>
                About
              </Link>
            </li>
            <li>
              <Link to='/privacy' className={css(style.list.link)}>
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to='/terms' className={css(style.list.link)}>
                Terms of Service
              </Link>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  </section>
]

export default Info



// WEBPACK FOOTER //
// ./src/components/Info/index.js